import React, { useState } from 'react';
import { ShoppingBag, Sparkles, Scroll, Gem, Mail, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../common/Button';
import { PixCheckoutModal } from '../payments/PixCheckoutModal';

// Vitrine modelo estática (checkout volta com os pagamentos)
const PRODUCTS = [
  {
    id: 'mapa-completo',
    name: 'Mapa Astral Completo',
    description: 'Relatório detalhado do seu mapa natal.',
    price: 79.9,
    icon: Sparkles,
  },
  {
    id: 'sinastria',
    name: 'Sinastria (Duas Cartas)',
    description: 'Compatibilidade detalhada entre duas pessoas.',
    price: 99.9,
    icon: Gem,
  },
  {
    id: 'relocacao',
    name: 'Relatório de Relocação',
    description: 'Seu mapa projetado em outra cidade.',
    price: 89.9,
    icon: Scroll,
  },
  {
    id: 'previsao',
    name: 'Previsões Anuais',
    description: 'Trânsitos do seu ano pessoal.',
    price: 129.9,
    icon: Mail,
  },
];

export const StorePage: React.FC = () => {
  const { user } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState<(typeof PRODUCTS)[number] | null>(null);
  const [checkoutProduct, setCheckoutProduct] = useState<(typeof PRODUCTS)[number] | null>(null);

  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
            <ShoppingBag className="w-8 h-8 text-purple-300" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-purple-200">Loja Astral</h2>
            <p className="text-purple-300/70">Produtos e serviços especiais</p>
          </div>
        </div>
        {user && (
          <span className="text-purple-200/70">
            Créditos: {user.credits}
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PRODUCTS.map((product) => {
          const Icon = product.icon;
          return (
            <div key={product.id} className="bg-white/10 backdrop-blur-lg rounded-lg p-4 flex flex-col">
              <div className="flex items-center space-x-3 mb-3">
                <div className="p-2 bg-purple-500/20 rounded-lg">
                  <Icon className="w-5 h-5 text-purple-300" />
                </div>
                <h3 className="text-lg font-medium text-purple-200">{product.name}</h3>
              </div>
              <p className="text-sm text-purple-200/70 flex-grow">
                {product.description}
              </p>
              <div className="flex items-center justify-between mt-4">
                <span className="text-lg font-bold text-purple-200">R$ {product.price.toFixed(2)}</span>
                <Button size="sm" onClick={() => setCheckoutProduct(product)}>
                  Comprar
                </Button>
              </div>
            </div>
          );
        })}
      </div>

      {selectedProduct && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-indigo-950 rounded-lg p-6 w-full max-w-md relative">
            <button
              onClick={() => setSelectedProduct(null)}
              className="absolute top-4 right-4 text-purple-200 hover:text-purple-100"
            >
              <X className="w-6 h-6" />
            </button>
            <h3 className="text-xl font-bold text-purple-200">{selectedProduct.name}</h3>
            <p className="text-purple-200/70 mt-2">{selectedProduct.description}</p>
            <div className="bg-white/10 rounded-lg p-4 mt-4">
              <div className="flex justify-between items-center">
                <span className="text-purple-200">Valor</span>
                <span className="text-lg font-bold text-purple-200">R$ {selectedProduct.price.toFixed(2)}</span>
              </div>
            </div>
            <button
              className="btn-primary w-full mt-4"
              onClick={() => {
                setCheckoutProduct(selectedProduct);
                setSelectedProduct(null);
              }}
            >
              Comprar
            </button>
          </div>
        </div>
      )}
      {/* Checkout Pix real (fase 2) — sobre o modal de detalhes */}
      {checkoutProduct && (
        <PixCheckoutModal productId={checkoutProduct.id} onClose={() => setCheckoutProduct(null)} />
      )}
    </div>
  );
};